import { render, staticRenderFns } from "./Aqui-estamos-preparados.vue?vue&type=template&id=22afcff0&scoped=true&"
import script from "./Aqui-estamos-preparados.vue?vue&type=script&lang=js&"
export * from "./Aqui-estamos-preparados.vue?vue&type=script&lang=js&"
import style0 from "./Aqui-estamos-preparados.vue?vue&type=style&index=0&id=22afcff0&scoped=true&lang=css&"
import style1 from "./Aqui-estamos-preparados.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afcff0",
  null
  
)

export default component.exports